import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  HStack,
  VStack,
  Text,
  Switch,
  Select,
  useToast,
  filter,
} from "@chakra-ui/react";

import React, { useEffect, useState } from "react";
import CrmDataService from "../../services/data";

export const FilterLeadModal = ({
  isOpen,
  onClose,
  func,
  filters,
  setFilters,
  pageId,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const accessControls =
    JSON.parse(localStorage.getItem("logged_in_user_accesscontrols") || "[]") ||
    [];
  const initialRef = React.useRef(null);

  const toast = useToast();

  const experts = [
    { name: "User1", id: "expert4_tamannarajpal" },
    { name: "User2", id: "expert_mahi" },
    { name: "User3", id: "expert_divanshi" },
    { name: "User4", id: "expert_navyav" },
    { name: "Prakriti", id: "expert_prakriti" },
    { name: "Jigyasa", id: "expert_jigyasa" },
    { name: "Tania", id: "expert_tania" },
  ];

  const ageOptions = ["17-24", "25-30", "31-35", "35-45", "45+"];

  const budgets = ["0", "<750", ">750", ">1000", "Flexible"];

  // ["Show All"]

  const handleSubmit = () => {
    if (
      (filters.last_followup_date.startDate &&
        !filters.last_followup_date.endDate) ||
      (!filters.last_followup_date.startDate &&
        filters.last_followup_date.endDate)
    ) {
      toast({
        position: "top",
        title: "Followup Date Range Error",
        description:
          "Kindly select both start and end dates for followup date.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    func();
    onClose();
  };

  useEffect(() => {
    setFilters({ ...filters, lead_age: "" });
  }, [pageId]);

  return (
    <>
      <Modal
        initialFocusRef={initialRef}
        isOpen={isOpen}
        onClose={onClose}
        size="lg"
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Filters</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl mb={6}>
              <FormLabel>Followup Date</FormLabel>
              <HStack spacing={10} ml={10}>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">From</FormLabel>
                  <Input
                    type="date"
                    value={filters.last_followup_date.startDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        last_followup_date: {
                          ...filters.last_followup_date,
                          startDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
                <VStack align="start" mb={0} spacing={0}>
                  <FormLabel fontWeight="normal">To</FormLabel>
                  <Input
                    type="date"
                    value={filters.last_followup_date.endDate}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        last_followup_date: {
                          ...filters.last_followup_date,
                          endDate: e.target.value,
                        },
                      });
                    }}
                  />
                </VStack>
              </HStack>
            </FormControl>

            <FormControl mb={6}>
              <FormLabel>Type</FormLabel>
              <Select
                value={filters.type}
                onChange={(e) =>
                  setFilters({ ...filters, type: e.target.value })
                }
              >
                <option value="">All</option>
                <option value="assigned">Assigned</option>
                <option value="marked">Marked</option>
              </Select>
            </FormControl>
            <FormControl mb={6}>
              <FormLabel>Type</FormLabel>
              <Select
                value={filters.type}
                onChange={(e) =>
                  setFilters({ ...filters, type: e.target.value })
                }
              >
                <option value="">All</option>
                <option value="assigned">Assigned</option>
                <option value="marked">Marked</option>
              </Select>
            </FormControl>

            {filters.type === "assigned" && (
              <FormControl mb={6}>
                <FormLabel>Assigned For</FormLabel>
                <Input
                  value={filters.assigned_for}
                  type="date"
                  onChange={(e) => {
                    setFilters({
                      ...filters,
                      assigned_for: e.target.value,
                    });
                  }}
                />
              </FormControl>
            )}

            {accessControls.includes("salesAdmin") && (
              <FormControl mb={4}>
                <FormLabel>Owner</FormLabel>
                <Select
                  placeholder="Select Owner"
                  value={filters.assigned_expert}
                  onChange={(e) => {
                    setFilters({ ...filters, assigned_expert: e.target.value });
                  }}
                >
                  {experts.map((el) => (
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  ))}
                </Select>
              </FormControl>
            )}

            {pageId === "cold-leads" && (
              <FormControl mb={4}>
                <FormLabel>Lead Age</FormLabel>
                <Input
                  value={filters.lead_age}
                  onChange={(e) => {
                    setFilters({ ...filters, lead_age: e.target.value });
                  }}
                />
              </FormControl>
            )}

            <FormControl mb={4}>
              <FormLabel>Budget</FormLabel>
              <Select
                placeholder="Select Budget"
                value={filters.budget}
                onChange={(e) => {
                  setFilters({ ...filters, budget: e.target.value });
                }}
              >
                {budgets.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </Select>
            </FormControl>

            <FormControl mb={4}>
              <FormLabel>Age</FormLabel>
              <Select
                placeholder="Select Age"
                value={filters.age}
                onChange={(e) => {
                  setFilters({ ...filters, age: e.target.value });
                }}
              >
                {ageOptions.map((el) => (
                  <option key={el} value={el}>
                    {el}
                  </option>
                ))}
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter justifyContent="space-between">
            <Button
              bgColor="#f48a0f"
              color={"white"}
              onClick={() => {
                setFilters({
                  assigned_expert: "",
                  budget: "",
                  age: "",
                  lead_age: "",
                  type: "",
                  assigned_for: "",
                  last_followup_date: { startDate: "", endDate: "" },
                });
                // func();
                // onClose();
              }}
            >
              Clear Filters
            </Button>
            <HStack gap={4}>
              <Button bgColor="#327171" color={"white"} onClick={handleSubmit}>
                Submit
              </Button>
              <Button bgColor={"red"} color={"white"} onClick={onClose}>
                Cancel
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
